import { render, staticRenderFns } from "./wxapp-visits.vue?vue&type=template&id=16dd79b1&scoped=true&"
import script from "./wxapp-visits.vue?vue&type=script&lang=js&"
export * from "./wxapp-visits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd79b1",
  null
  
)

export default component.exports